import gql from 'graphql-tag';
import FRAGMENTS from '_Resources/Cards/Services/GraphQl/FRAGMENTS';

const query = gql`
  query getDataByFiltersCardData(
    $projectId: Int!
    $range: DateRangeInput!
    $criteriaKeys: [CriteriaKey!]
    $thematics: [ThematicInput!]
    $keywords: [String!]
    $selectedCriteriaKey: String!
    $dataCollectorId: Int
  ) {
    getDataByFiltersCardData(
      projectId: $projectId
      range: $range
      criteriaKeys: $criteriaKeys
      thematics: $thematics
      keywords: $keywords
      selectedCriteriaKey: $selectedCriteriaKey
      dataCollectorId: $dataCollectorId
    ) {
      criteriaKeyLabel
      eindex {
        ...KpiResultsFragment
      }
      emotions {
        ...EmotionsBreakdownFragment
      }
      mentions
      recommendation {
        ...KpiResultsFragment
      }
      satisfaction {
        ...KpiResultsFragment
      }
      effort {
        ...KpiResultsFragment
      }
    }
  }
  ${FRAGMENTS.kpiResults}
  ${FRAGMENTS.emotionsBreakdown}
`;

export default query;
